import {
  ApplicationInsights,
  SeverityLevel,
} from "@microsoft/applicationinsights-web";

let appInsights;

export function initAppInsights(connectionString) {
  appInsights = new ApplicationInsights({
    config: {
      connectionString: connectionString,
    },
  });

  appInsights.loadAppInsights();
  return appInsights;
}

// Log a success/info message
export function logSuccess(message, properties) {
  if (appInsights) {
    appInsights.trackEvent(
      { name: "SuccessMessage" },
      { message, ...properties }
    );
  }
}

// Log an error message
export function logError(error, properties) {
  if (appInsights) {
    appInsights.trackException({
      exception: error instanceof Error ? error : new Error(error),
      severityLevel: SeverityLevel.Error,
    });
    // Optionally also as a custom event:
    appInsights.trackEvent(
      { name: "ErrorMessage" },
      { message: error, ...properties }
    );
  }
}
